import React from "react";
import { Chip, Stack } from "@mui/material";

import { BOX_STATUS_OPTIONS } from "../../constants/boxing";

const sx = {
  "& .MuiChip-label": {
    fontSize: 10,
    fontWeight: 500,
  },
};

export const ShipmentOrdersStatusChip = ({ item }) => {
  const status = BOX_STATUS_OPTIONS.find((b) => b.id === item?.status);

  return (
    <Chip
      variant="colorTag"
      label={status?.label}
      flow={status?.flow}
      sx={sx}
    />
  );
};

export default ShipmentOrdersStatusChip;
